import ApiUtils from '@/utils/api/ApiUtils'
import ObjArrUtils from '@/utils/ObjArrUtils'

const module = {
  state: {
  },

  getters: {

  },

  mutations: {

  },
  actions: {
  }
}

export default ObjArrUtils.merge(module)
